import React from "react";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { useExpertOnboardingContext, useExpertProfileContext } from "@limitless/expert";
import {
    ConversationHeader,
    ExpertConversation,
    LoadingSpinner,
    ConversationReviewCriteriaPanel
} from "@limitless/portal";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";

const useStyles = makeStyles({
    root: {
        height: "calc(100vh - 70px)",
        flexWrap: "nowrap"
    },
    dialogues: {
        overflowX: "auto",
        padding: "2px 0px 16px 16px",
        overflow: "auto",
        height: "100%",
        width: "100%",
        paddingBottom: 65
    },
    loadingContainer: {
        display: "flex",
        flex: 1,
        justifyContent: "center"
    }
});

const OnboardingConversation = () => {
    const classes = useStyles();
    const { countryList } = useAppConfig();
    const { profile } = useExpertProfileContext();
    const { loading, message, clearSelectedMessage } = useExpertOnboardingContext();

    const messageWithState = { ...message, conversationState: { type: "respond" } };
    const { isDarkMode } = useExpertProfileContext();

    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    return loading ? (
        <div className={classes.loadingContainer}>
            <LoadingSpinner />
        </div>
    ) : (
        <ThemeProvider theme={theme}>
            <Grid container direction="row" className={classes.root}>
                <Grid container direction="row">
                    <Grid item xs={12}>
                        <ConversationHeader message={messageWithState} clearMessage={() => null} />
                    </Grid>
                    <Grid item className={classes.dialogues}>
                        <ExpertConversation
                            profile={profile}
                            isParentLoading={false}
                            countryList={countryList}
                            message={messageWithState}
                        />
                    </Grid>
                </Grid>
                <Grid item>
                    <ConversationReviewCriteriaPanel message={messageWithState} onBackClick={clearSelectedMessage} />
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};

export default OnboardingConversation;
